'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var btnStyle = {
	backgroundImage: 'url("https://www.paypalobjects.com/webstatic/mktg/consumer/onboarding/ui-sprite.png")',
	backgroundPosition: '-27px -3486px',
	minWidth: 27,
	padding: '9px 20px',
	margin: '1rem'
};

var STYLES = {
	audio: {
		marginTop: '1rem',
		width: '100%'
	},
	audioBtn: Object.assign({}, btnStyle, {
		backgroundPosition: '-27px -3486px'
	}),
	refreshBtn: Object.assign({}, btnStyle, {
		backgroundPosition: '-27px -3386px'
	}),
	form: {
		border: '1px solid rgb(157, 163, 166)',
		borderRadius: 5,
		margin: '0 auto',
		maxWidth: 500,
		padding: 35,
		textAlign: 'center',
		width: '100%'
	},
	captchaImage: {
		border: '1px solid rgb(203, 210, 214)',
		borderRadius: 5,
		marginBottom: '1rem',
		padding: '1rem'
	}
};

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		height: 0,
		maxWidth: 315,
		margin: '0 auto',
		transition: 'all 0.25s ease-in-out'
	},

	errorShown: {
		height: '100%'
	}
});

var Captcha = function (_React$Component) {
	_inherits(Captcha, _React$Component);

	function Captcha() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Captcha);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Captcha.__proto__ || Object.getPrototypeOf(Captcha)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			showAudio: false,
			answer: ''
		}, _this.toggleAudio = function () {
			_this.setState({
				showAudio: !_this.state.showAudio
			});
		}, _this.updateAnswer = function (answer) {
			_this.props.updateAnswer(answer);
			_this.setState({ answer: answer });
			return answer;
		}, _this.submitAnswer = function (event) {
			event.preventDefault();
			_this.props.submitAnswer(_this.state.answer);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Captcha, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    verifyContent = _props.verifyContent,
			    submitContent = _props.submitContent,
			    textInputLabel = _props.textInputLabel,
			    refreshContent = _props.refreshContent,
			    toggleAudioContent = _props.toggleAudioContent,
			    _props$errorMessage = _props.errorMessage,
			    errorMessage = _props$errorMessage === undefined ? '' : _props$errorMessage,
			    _props$showErrorMessa = _props.showErrorMessage,
			    showErrorMessage = _props$showErrorMessa === undefined ? false : _props$showErrorMessa,
			    handleCaptchaBlur = _props.handleCaptchaBlur;
			var _props$captchaObject = this.props.captchaObject,
			    captchaImgUrl = _props$captchaObject.captchaImgUrl,
			    captchaAudioUrl = _props$captchaObject.captchaAudioUrl;


			var captchaWrapperClassNames = (0, _classnames2.default)({
				'vx_has-error-with-message': errorMessage && showErrorMessage
			});

			var captchaAudioClass = this.state.showAudio ? '' : 'hide';

			return _react2.default.createElement(
				'form',
				{ onSubmit: this.submitAnswer, style: STYLES.form },
				_react2.default.createElement(
					'h2',
					null,
					verifyContent
				),
				_react2.default.createElement('img', { style: STYLES.captchaImage, src: captchaImgUrl }),
				_react2.default.createElement(
					'div',
					{ className: captchaWrapperClassNames, style: { margin: '10px 0' } },
					_react2.default.createElement(_reactTextInput2.default, {
						name: 'captchaImage',
						id: 'captchaImage',
						className: 'vx_form-control vx_form-control_complex',
						label: textInputLabel,
						required: true,
						value: this.state.answer,
						handleChange: this.updateAnswer,
						handleBlur: handleCaptchaBlur }),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, errorMessage && styles.errorShown), {
								'vx_form-control-message': errorMessage
							}) },
						errorMessage
					)
				),
				_react2.default.createElement(
					'audio',
					{ id: 'captchaAudio',
						controls: 'controls',
						src: captchaAudioUrl,
						className: captchaAudioClass,
						style: STYLES.audio },
					_react2.default.createElement('embed', { height: '50', width: '100', src: captchaAudioUrl })
				),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'vx_btn vx_btn-secondary btn refresh', style: STYLES.refreshBtn, title: refreshContent, onClick: this.props.refreshCaptcha },
						'\xA0'
					),
					_react2.default.createElement(
						'div',
						{ className: 'vx_btn vx_btn-secondary btn audio', style: STYLES.audioBtn, title: toggleAudioContent, onClick: this.toggleAudio },
						'\xA0'
					)
				),
				_react2.default.createElement(
					'button',
					{ className: 'vx_btn' },
					submitContent
				)
			);
		}
	}]);

	return Captcha;
}(_react2.default.Component);

Captcha.propTypes = {
	captchaObject: _propTypes2.default.shape({
		captchaImgUrl: _propTypes2.default.string.isRequired,
		captchaAudioUrl: _propTypes2.default.string.isRequired
	}).isRequired,

	verifyContent: _propTypes2.default.string,
	submitContent: _propTypes2.default.string,
	textInputLabel: _propTypes2.default.string,
	refreshContent: _propTypes2.default.string,
	toggleAudioContent: _propTypes2.default.string,
	errorMessage: _propTypes2.default.string,
	showErrorMessage: _propTypes2.default.bool,

	refreshCaptcha: _propTypes2.default.func.isRequired,
	submitAnswer: _propTypes2.default.func.isRequired,
	handleCaptchaBlur: _propTypes2.default.func.isRequired,
	updateAnswer: _propTypes2.default.func.isRequired
};
Captcha.defaultProps = {
	handleCaptchaBlur: function handleCaptchaBlur() {},
	updateAnswer: function updateAnswer() {}
};
exports.default = Captcha;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Captcha.js
// module id = 708
// module chunks = 5